import { render, staticRenderFns } from "./RoomSettings.vue?vue&type=template&id=596aca96&"
import script from "./RoomSettings.vue?vue&type=script&lang=js&"
export * from "./RoomSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports